// extracted by mini-css-extract-plugin
module.exports = {"customizeSummary":"styles-module__customizeSummary___3sfpw","footer":"styles-module__footer___pjwPr"};